export enum GroupTypeIds {
  Member = '1',
  RSIUser = '4',
  Canadian = '11',
  Unknown = '-1',
}
